import type { Resource } from '../../';
export const language_nl: Resource = {"default":"Dutch"};
